/**
 * Skip Link Component - WCAG AA Compliance
 * Permet aux utilisateurs de clavier de passer directement au contenu principal
 */

export const SkipLink = () => {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground focus:rounded-lg focus:shadow-lg focus:outline-none focus:ring-4 focus:ring-ring"
    >
      Aller au contenu principal
    </a>
  );
};
